module.exports = __webpack_public_path__ + "img/diamond-2.081e81b1.png";